import { render, staticRenderFns } from "./music-select.vue?vue&type=template&id=56afe7c2&scoped=true"
import script from "./music-select.vue?vue&type=script&lang=js"
export * from "./music-select.vue?vue&type=script&lang=js"
import style0 from "./music-select.vue?vue&type=style&index=0&id=56afe7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afe7c2",
  null
  
)

export default component.exports